import { useAuthStore } from '../store/auth'

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuthStore()
  authStore.getToken()
  if (authStore.isAuthenticated) {
    return navigateTo('/')
  }
})
